import {ProfileImage} from '@/types/models/search-creators/searchCreators';

function getProfileImageUrl(profileImage?: ProfileImage) {
  return (
    profileImage?.image?.thumbnail ??
    profileImage?.image?.full ??
    profileImage?.image?.original ??
    profileImage?.socialPlatformsImages?.at(0) ??
    ''
  );
}

export default getProfileImageUrl;
